import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/home/Home';
import AboutUs from './pages/about/AboutUs';
import Courses from './pages/courses/Courses';
import CourseDetails from './pages/courses/CourseDetails';
import Feedback from './pages/feedback/Feedback';
import Faq from './pages/faq/Faq';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import AdminDashboard from './pages/admin/AdminDashboard';
import StudentDashboard from './pages/student/StudentDashboard';
import Exams from './pages/student/Exams';
import Payments from './pages/student/Payments';
import Profile from './pages/student/Profile';
import MyCourses from './pages/student/MyCourses';
import MonthSelection from './pages/student/MonthSelection';
import CourseMaterials from './pages/student/CourseMaterials';
import AllCourses from './pages/student/AllCourses';
import SecurityWrapper from './components/security/SecurityWrapper';

function App() {
  return (
    <SecurityWrapper>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/course-details/:courseId" element={<CourseDetails />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/student/dashboard" element={<StudentDashboard />} />
        <Route path="/student/courses" element={<MyCourses />} />
        <Route path="/student/all-classes" element={<AllCourses />} />
        <Route path="/student/course-months/:courseId" element={<MonthSelection />} />
        <Route path="/student/materials/:monthId" element={<CourseMaterials />} />
        <Route path="/student/exams" element={<Exams />} />
        <Route path="/student/payments" element={<Payments />} />
        <Route path="/student/profile" element={<Profile />} />
      </Routes>
    </Router>
    </SecurityWrapper>
  );
}

export default App;
